import React, { useState, useRef, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useAuth } from './AuthContext'
import app from './firebase'
import BlockSts, { V } from "./BlockSts"
import './Test.css'
import GraphwithList from './GraphwthList'
import './BlockSts.css'
import swal from 'sweetalert'

const Va = React.createContext()
export function useVal() {
    return useContext(Va);
}
export default function Dashbord() {
    const { currentUser } = useAuth()
    const {signout}=useAuth()
    const [email, setEmail] = useState()
    const [dat, setDat] = useState({})
    const [oo, setOO] = useState(0)
    var [ARR, setARR] = useState(0)
    const [cc, setCoun] = useState(0)
    const [totallamount, setTotall] = useState(0)
    //const [object, setObject] = useState({})
    //const { DES } = useVal()

    useEffect(
        () => {
            var g = (currentUser.email).split(".")
            if (amnt.current.value === null || amnt.current.value === '' || amnt.current.value === undefined) { }
            else {
                var obj = { [new Date().toDateString()]: amnt.current.value, [new Date().toDateString() + "descrip"]: des.current.value }
                app.child(g[0]).push(obj, err => {
                    if (err) {
                        alert("error")
                    }
                })
            }
            //console.log(summm,ARR)    
        }, [cc]
    )

    /*useEffect(
        ()=>{
            var userr=(currentUser.email).split('.')
            app.child(userr[0]).on("value",(snapshot)=>{
                if(snapshot.val()){

                }
            })
        },
        []
    )
    */

    const amnt = useRef()
    const history = useHistory()
    const des = useRef()
    const [AM, setAM] = useState()
    const [DES, setDes] = useState()
    const [dbob, setdbob] = useState({})
    useEffect(() => {
        var amunIndx = 0
        var desArray = []
        var pri = Object.keys(dbob).map(id => {
            desArray = [...desArray, Object.keys(dbob[id])[0]]
            var dt = new Date().toDateString()
            if (typeof dbob[id][dt] !== 'undefined') {
                var d = dbob[id][dt]
                return d
            }
        })
        const totallAmountArray = Object.keys(dbob).map(id => {
            return dbob[id][desArray[amunIndx++]]
        })
        console.log(totallAmountArray)
        function inte(pri) {
            if (typeof pri == "undefined") {
                return 0
            }
            else {
                return parseInt(pri)
            }
        }
        // var inttotalAmount=totallAmountArray.filter(inte)
        //console.log("intttl"+inttotalAmount)
        var po = pri.filter(inte)
        var totallAmount = totallAmountArray.reduce((a, b) => parseInt(a) + parseInt(b), 0)
        console.log("ttl" + " " + totallAmount)
        console.log('last', po[po.length - 1])
        var summm = po.reduce((a, b) => parseInt(a) + parseInt(b), 0)
        setTotall(totallAmount)
        setOO(summm)
    }, [dbob])

    useEffect(() => {
        var g = (currentUser.email).split(".")
        app.child(g[0]).on("value", (snapshot) => {
            if (snapshot.val()) {
                setdbob({
                    ...snapshot.val()
                })

            }
        })
    }, [])

    function ADd(e) {
        e.preventDefault();
        if (amnt.current.value === null || amnt.current.value === "") {
            swal({

                text: "enter amount",
                icon: "warning",
                button: "ok",
            })
        }
        if (parseInt(amnt.current.value) < 0) {
            swal({

                text: "enter positive amount",
                icon: "warning",
                button: "ok",
            })
        }
        else {
            setAM(amnt.current.value)
            setDes(des.current.value)
            var c = Math.random()
            c++
            setCoun(c)
            return amnt.current.value
        }
    }
    async function handleLogout(e) {
        e.preventDefault()
        try {
            await signout()
            history.push('./login')
            // signed out
        } catch (e) {
            // an error
            swal({
                title:e.message,
                text: "faild to signout",
                icon: "warning",
                button: "ok",
            })
        }
        // history.push('./login')
    }
    function openNav() {
        document.getElementById("mySidenav").style.width = "300px";
        document.getElementById("navbar").style.display = "none";
    }
    function closeNav() {
        document.getElementById("mySidenav").style.width = "0";
        document.getElementById("navbar").style.display = "block";
    }
    function autoResize() {
        document.querySelector("#txtAr").style.height = 'auto'
        document.querySelector("#txtAr").style.height = document.querySelector("#txtAr").scrollHeight + 'px'
    }
    const vall = {
        AM,
        DES,
        dbob
    }
    return (
        <div id="CONT">
            <div id="profile">
                <div id="mySidenav" class="sidenav">
                    <a href="javascript:void(0)" class="closebtn" onClick={closeNav} >&times;</a>
                    <div id="ProfPhoto">
                        <img src={`https://joeschmoe.io/api/v1/random${(currentUser.email).split("@")[0]}`}></img>
                    </div>
                    <h3 style={{ color: 'white', position: 'relative', marginLeft: '130px' }}>{(currentUser.email).split("@")[0]}</h3>
                    <button id="logout" onClick={handleLogout}>LOG OUT</button>
                </div>
                <span onClick={openNav} id="navbar">&#9776; </span>
                <div id="form">
                    <form>
                        <input type="text" placeholder="Enter amount" ref={amnt} required></input><br />
                        <textarea id="txtAr" onChange={autoResize} placeholder='description' ref={des} required></textarea>
                        <button onClick={ADd}>Add</button>
                    </form>
                </div>
            </div>
            <div id="StswithGrphCont">
                <div id="stsContt">
                    <BlockSts dwy="today" incr={`${oo}px`} A="anim" time="4s" Rupee={oo} ></BlockSts>
                    <BlockSts dwy="Total" incr="50px" A="ani" time="4s" Rupee={totallamount}></BlockSts>

                </div>
                <div id="GraphLCont">
                    <Va.Provider value={vall}>
                        <GraphwithList />
                    </Va.Provider>
                </div>
            </div>
        </div>
    )
}
